import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  buttonSave: {
    background: '#54c6e8',
    color: '#fff',
    width: 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'capitalize',
    '&:hover': {
      background: '#549ce8',
    },
  },
  buttonDisabled: {
    background: '#f1f1f1',
    color: '#a6a6a6',
    cursor: 'default',
    width: 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'capitalize',
    pointerEvents: 'none',
  },
}));

const EditButton = ({ children, onClick, disabled }) => {
  const classes = useStyles();
  return (
    <Button variant="contained" className={disabled ? classes.buttonDisabled : classes.buttonSave} onClick={onClick}>
      <Typography>{children}</Typography>
    </Button>
  );
};
EditButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

EditButton.defaultProps = {};

export default EditButton;
